import { notifyParent } from 'mailup-react-helpers'

const setMenuItem = (pageId) => {
  const { pathname, search } = window.location
  const p = pathname.match(/\/\d+(\/[^?]+)/)[1]
  const redirect = `recipients_app_redirector.aspx?r=${encodeURIComponent(
    `${p}${search}`,
  )}`

  notifyParent('selectMenuItemReact', [pageId, redirect])
}

export default setMenuItem
